 

export const navigation = [
  {
    text: 'Anasayfa',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Asgari Ücret Tanım',
    path: '/AsgariUcretTanim',
    icon: 'home'
  },
  {
    text: 'Gösterge 4a Tanım',
    path: '/GostergeTanim',
    icon: 'home'
  },
  {
    text: 'Gösterge 4b Tanım',
    path: '/Gosterge4bTanim',
    icon: 'home'
  },
  {
    text: 'Kazanc Tanım',
    path: '/KazancTanim',
    icon: 'home'
  },
  {
    text: 'Enflasyon Tanım',
    path: '/EnflasyonTanim',
    icon: 'home'
  },
  {
    text: 'Emeklilik Koşul Tanım',
    path: '/EmeklililikKosul',
    icon: 'home'
  },
  {
    text: 'HizmetForm',
    path: '/HizmetForm',
    icon: 'home'
  } ,
  {
    text: 'HesapForm',
    path: '/HesapForm',
    icon: 'home'
  } ,
  {
    text: 'Kazanç Senaryosu',
    path: '/KullaniciHesap',
    icon: 'home'
  } 
  // {
  //   text: 'Examples',
  //   icon: 'box',
  //   items: [
  //     {
  //       text: 'Profile',
  //       path: '/profile'
  //     },
  //     {
  //       text: 'Display Data',
  //       path: '/display-data'
  //     }
  //   ]
  // }
  ];
